import { create } from "zustand";
import {
  consolidatedWorkerState,
  ConsolidatedWorkerContext,
} from "./consolidatedWorkerContext.types";

export const INITIAL_CONSOLIDATED_WORKER_STATE: consolidatedWorkerState = {
  consolidatedWorkers: [],
  consolidatedProfile: null,
};

export const useConsolidatedWorkerContext = create<ConsolidatedWorkerContext>(
  (commit) => ({
    ...INITIAL_CONSOLIDATED_WORKER_STATE,

    getConsolidatedWorkers(consolidatedWorkers) {
      commit((state) => ({
        ...state,
        consolidatedWorkers,
      }));
    },

    getConsolidatedProfile(consolidatedProfile) {
      commit((state) => ({
        ...state,
        consolidatedProfile,
      }));
    },
    clearDetails() {
      commit((state) => ({
        ...state,
        consolidatedWorkers: [],
        consolidatedProfile: null,
      }));
    },
  })
);
